import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 48px;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #282E33;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #3B444C;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #22272B;
  border-radius: 8px 8px 0 0;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #8C9BAB;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #B6C2CF;
  }
`;

export const Form = styled.form`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  flex-grow: 1;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  color: #B6C2CF;
  background: #22272B;
  transition: all 0.2s ease;

  &:focus {
    border-color: #579DFF;
    outline: none;
    background: #22272B;
  }

  &:hover {
    border-color: #465059;
  }

  &::placeholder {
    color: #8C9BAB;
  }
`;

export const Select = styled.select`
  padding: 8px 12px;
  border: 2px solid #3B444C;
  border-radius: 3px;
  font-size: 14px;
  color: #B6C2CF;
  background: #22272B;
  transition: all 0.2s ease;

  &:focus {
    border-color: #579DFF;
    outline: none;
    background: #22272B;
  }

  &:hover {
    border-color: #465059;
  }
`;

export const PreviewCard = styled.div`
  margin-top: 16px;
  border: 1px solid #dcdde1;
  border-radius: 8px;
  overflow: hidden;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  background: #f5f5f5;
`;

export const PreviewContent = styled.div`
  padding: 16px;
`;

export const PreviewTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #B6C2CF;
`;

export const PreviewUrl = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  color: #7f8c8d;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(Button)`
  background: transparent;
  border: none;
  color: #B6C2CF;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SaveButton = styled(Button)`
  background: #579DFF;
  border: none;
  color: white;

  &:hover:not(:disabled) {
    background: #398BFF;
  }

  &:disabled {
    background: #579DFF;
    opacity: 0.5;
  }
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #f5f6fa;
  border-top-color: #0984e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorMessage = styled.p`
  margin: 8px 0 0;
  color: #e74c3c;
  font-size: 14px;
`;

export const InfoMessage = styled.p`
  margin: 8px 0 0;
  color: #3498db;
  font-size: 14px;
  background-color: rgba(52, 152, 219, 0.1);
  padding: 8px;
  border-radius: 4px;
  border-left: 3px solid #3498db;
`;

export const TagInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; // Add some gap between items

  // Child div containing the input field
  > div:first-child {
    flex-grow: 1;
    position: relative; // For suggestions panel
  }

  // Child div containing color pickers
  > div:nth-child(2) {
    display: flex;
    flex-shrink: 0; // Prevent color pickers from shrinking
  }

  // Add Tag button
  > button {
    white-space: nowrap;
    padding: 8px 12px; // Consistent padding
    flex-shrink: 0; // Prevent button from shrinking
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch; // Make items take full width

    // Child div containing the input field
    > div:first-child {
      width: 100%;
      margin-bottom: 10px; // Space below input field
    }

    // Container for color pickers and Add Tag button for mobile layout
    > .tag-actions-mobile-wrapper {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      gap: 10px; // Space between color pickers and button
    }

    // Child div containing color pickers
    > div:nth-child(2),
    .tag-actions-mobile-wrapper > div:first-child { // Targeting color pickers div
      margin-right: 0; // Remove right margin
      margin-bottom: 10px; // Space below color pickers
      justify-content: center; // Center the color buttons
      flex-wrap: wrap; // Allow color buttons to wrap
      gap: 5px; // Gap between color buttons
    }

    // Add Tag button
    > button,
    .tag-actions-mobile-wrapper > button {
      width: 100%; // Make button full width
      margin-top: 0; // Reset margin if any from desktop
    }
  }
`;